import MainHall from './MainHall.js'
import RoundHall from './RoundHall.js'
import MiniParther from './MiniParther.js'
import ShortParther from './ShortParther.js'
import Pitsunda from './Pitsunda.js'
import Chamber from './Chamber.js'

export default [
  { label: 'Большая сцена', type: 'main-hall', hall: MainHall.hall },
  { label: 'Круговая сцена', type: 'round-hall', hall: RoundHall.hall },
  { label: 'Малая сцена', type: 'short-parter', hall: ShortParther.hall },
  { label: 'Камерная сцена', type: 'chamber', hall: Chamber.hall },
  {
    label: 'Арт-фойе',
    type: 'mini-parter',
    hall: MiniParther.hall
  },
  // { label: 'Фойе', type: 'foyer' },
  // { label: 'Зал со столами', type: 'tables' },
  { label: 'Зал Пицундского храма', type: 'pitsunda', hall: Pitsunda.hall }
]
